import React from 'react';
import { Instagram, Mail, MapPin, MessageCircle } from 'lucide-react';
import CivicButton from './CivicButton';
import { CONTACT_EMAIL, WHATSAPP_CHAT_URL } from '../constants/links';

const EXTERNAL = { target: '_blank', rel: 'noopener noreferrer' } as const;

const ContactBlock: React.FC = () => {
  return (
    <div className="contact__layout">
      <address className="contact__directory">
        <div className="contact__row">
          <span className="contact__icon" aria-hidden="true">
            <Mail size={18} />
          </span>
          <div>
            <p className="contact__label">Correo</p>
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </div>
        </div>
        <div className="contact__row">
          <span className="contact__icon" aria-hidden="true">
            <Instagram size={18} />
          </span>
          <div>
            <p className="contact__label">Instagram</p>
            <a href="https://www.instagram.com/unavozdiferente.pe/" {...EXTERNAL}>
              @unavozdiferente.pe
            </a>
            <a href="https://www.instagram.com/cumbreciudadanoycreyente/" {...EXTERNAL}>
              @cumbreciudadanoycreyente
            </a>
          </div>
        </div>
        <div className="contact__row">
          <span className="contact__icon" aria-hidden="true">
            <MapPin size={18} />
          </span>
          <div>
            <p className="contact__label">Ubicación</p>
            <p>Lima, Perú</p>
          </div>
        </div>
      </address>
      <aside
        className="contact__panel"
        style={{ background: '#FAFAF7', color: '#1A2332', border: '1px solid #d8d6d0' }}
      >
        <h3 className="contact__panel-title" style={{ color: '#1A2332' }}>
          ¿Listo para ser el cambio?
        </h3>
        <p className="contact__panel-text" style={{ color: '#1A2332' }}>
          Únete a nuestro chat de difusión de WhatsApp.
        </p>
        <CivicButton
          href={WHATSAPP_CHAT_URL}
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<MessageCircle size={16} />}
          size="large"
        >
          Únete al Chat
        </CivicButton>
      </aside>
    </div>
  );
};

export default ContactBlock;
